import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SongsComponent } from './songs.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    SongsComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class SongsModule { }
